import { Box } from "@mui/material";
import { useCallback } from "react";
import { spacing } from "../../styles/theme";
import SpecsRightSidebarStyleChip from "./SpecsRightSidebarStyleChip";
import { useSpecsEditorContextValue } from "./useSpecsEditor";

export default function SpecsStyleSelector() {
  const { editor, nav, selectedElementModel, selectedStyleName } =
    useSpecsEditorContextValue();

  const handleStyleClick = useCallback(
    (styleName: string) => {
      if (
        !selectedElementModel ||
        (nav.kind !== "element" &&
          nav.kind !== "layer" &&
          nav.kind !== "positions")
      ) {
        return;
      }

      editor.selectElement(
        nav.part || "",
        selectedElementModel.name,
        styleName
      );
    },
    [editor, nav, selectedElementModel]
  );

  if (!selectedElementModel || selectedElementModel.styles.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: spacing.xsDesktop,
      }}
    >
      {selectedElementModel.styles.map((style) => (
        <SpecsRightSidebarStyleChip
          key={style.name}
          style={style}
          active={selectedStyleName === style.name}
          onClick={() => handleStyleClick(style.name)}
        />
      ))}
    </Box>
  );
}
